import { useState, useEffect } from 'react';
import { FigureModel } from '../models';
import { getAllOgs, getAllNftsFromAlchemy } from '../providers/AlchemyProvider';
import { BASEJUMP_CONTRACT_ADDRESS } from '../constants';
import { Network } from 'alchemy-sdk';

const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

const MOCK_FIGURES = [
  {
    id: 7160,
    name: 'Mock #7160',
    vrm: '/mocks/figures/Broadside_7160.vrm',
    glb: '/mocks/figures/Broadside_7160.glb',
    image: '/mocks/figures/7160.png'
  },
  {
    id: 30584,
    name: 'Mock #30584',
    vrm: '/mocks/figures/Broadside_30584.vrm',
    glb: '/mocks/figures/Broadside_30584.glb',
    image: '/mocks/figures/30584.png'
  },
  {
    id: 3190,
    name: 'Mock #3190',
    vrm: '/mocks/figures/Broadside_3190.vrm',
    glb: '/mocks/figures/Broadside_3190.glb',
    image: '/mocks/figures/3190.png'
  },
  {
    id: 66,
    name: 'New #60165',
    vrm: '/mocks/figures/Broadside_60165.vrm',
    glb: '/mocks/figures/Broadside_60165.glb',
    image: '/mocks/figures/Grouse.png'
  },
  {
    id: 67,
    name: 'New #60106',
    vrm: '/mocks/figures/Broadside_60106.vrm',
    glb: '/mocks/figures/Broadside_60106.glb',
    image: '/mocks/figures/Grouse.png'
  },
  {
    id: 61,
    name: 'Default',
    vrm: '/mocks/figures/BaseJump_Default_Avatar.vrm',
    glb: '/mocks/figures/BaseJump_Default_Avatar.glb',
    image: '/mocks/figures/Grouse.png'
  },
  {
    id: 50,
    name: 'OG',
    vrm: '/mocks/figures/default_1177.vrm',
    glb: '/mocks/figures/default_1177.glb',
    image: '/mocks/figures/Eridan.png'
  },
  {
    id: 51,
    name: 'Shortie',
    vrm: '/mocks/figures/shortie_880.vrm',
    glb: '/mocks/figures/shortie_880.glb',
    image: '/mocks/figures/Eridan.png'
  },
  {
    id: 52,
    name: 'N00b',
    vrm: '/mocks/figures/n00b_95.vrm',
    glb: '/mocks/figures/n00b_95.glb',
    image: '/mocks/figures/Eridan.png'
  },
  {
    id: 53,
    name: 'Henchie',
    vrm: '/mocks/figures/henchie_616.vrm',
    glb: '/mocks/figures/henchie_616.glb',
    image: '/mocks/figures/Eridan.png',
    isHenchie: true
  },
  {
    id: 5,
    name: 'Eridan',
    vrm: '/mocks/figures/BROADSIDE3190-Eridan.vrm',
    glb: '/mocks/figures/BROADSIDE3190-Eridan.glb',
    image: '/mocks/figures/Eridan.png'
  },
  {
    id: 1,
    name: 'Hermit',
    vrm: '/mocks/figures/BROADSIDE1842-Hermit.vrm',
    glb: '/mocks/figures/BROADSIDE1842-Hermit.glb',
    image: '/mocks/figures/Hermit.png'
  },
  {
    id: 2,
    name: 'Boulder',
    vrm: '/mocks/figures/BROADSIDE200-Boulder.vrm',
    glb: '/mocks/figures/BROADSIDE200-Boulder.glb',
    image: '/mocks/figures/Boulder.png'
  },
  {
    id: 3,
    name: 'Grouse',
    vrm: '/mocks/figures/BROADSIDE2566-Grouse.vrm',
    glb: '/mocks/figures/BROADSIDE2566-Grouse.glb',
    image: '/mocks/figures/Grouse.png'
  },
  {
    id: 4,
    name: 'Eridan-PBR',
    vrm: '/mocks/figures/BROADSIDE3190-Eridan-pbr.vrm',
    glb: '/mocks/figures/BROADSIDE3190-Eridan-pbr.glb',
    image: '/mocks/figures/Eridan-pbr.png'
  },
  {
    id: 6,
    name: 'Raelynn',
    vrm: '/mocks/figures/BROADSIDE5159-Raelynn.vrm',
    glb: '/mocks/figures/BROADSIDE5159-Raelynn.glb',
    image: '/mocks/figures/Raelynn.png'
  },
  {
    id: 7,
    name: 'Possum',
    vrm: '/mocks/figures/BROADSIDE6635-Possum.vrm',
    glb: '/mocks/figures/BROADSIDE6635-Possum.glb',
    image: '/mocks/figures/Possum.png'
  },
  {
    id: 8,
    name: 'Sven',
    vrm: '/mocks/figures/BROADSIDE930-Sven.vrm',
    glb: '/mocks/figures/BROADSIDE930-Sven.glb',
    image: '/mocks/figures/Sven.png'
  },
  {
    id: 9,
    scaleFactor: 0.17,
    name: 'Warpsound-02',
    vrm: '/mocks/figures/Warpsound_0002.gltf',
    glb: '/mocks/figures/Warpsound_0002.gltf',
    image: '/mocks/figures/W2.avif'
  },
  {
    id: 9,
    scaleFactor: 0.17,
    name: 'Warpsound-03',
    vrm: '/mocks/figures/Warpsound_0003.gltf',
    glb: '/mocks/figures/Warpsound_0003.gltf',
    image: '/mocks/figures/W3.avif'
  }
];

const DEFAULT_FIGURES = [
  {
    id: '000000',
    name: 'Default',
    vrm: '/assets/free_avatar.vrm',
    glb: '/assets/free_avatar.glb',
    image: '/assets/free_avatar.png'
  },
  {
    id: '100001',
    name: 'Default - Mesh',
    vrm: '/assets/Default_Avatar_UVs.vrm',
    glb: '/assets/Default_Avatar_UVs.glb',
    image: '/assets/mesh_avatar.png'
  },
  {
    id: '100002',
    name: 'Henchie - Mesh',
    vrm: '/assets/Gigachad_Default_Avatar_UVs.vrm',
    glb: '/assets/Gigachad_Default_Avatar_UVs.glb',
    image: '/assets/gigachad.jpg',
    isHenchie: true
  },
  {
    id: '100003',
    name: 'n00b - Mesh',
    vrm: '/assets/n00b_Default_Avatar_UVs.vrm',
    glb: '/assets/n00b_Default_Avatar_UVs.glb',
    image: '/assets/n00b.jpg'
  },
  {
    id: '100004',
    name: 'Shortie - Mesh',
    vrm: '/assets/Shortie_Default_Avatar_UVs.vrm',
    glb: '/assets/Shortie_Default_Avatar_UVs.glb',
    image: '/assets/shortie.jpg'
  }
]

const HOMESCREEN_MODELS = [ 
  {
    id: '0000',
    name: 'Default',
    vrm: '/assets/default_avatar.vrm',
    glb: '/assets/default_avatar.vrm',
    image: '/assets/default_avatar.png'
  },
  {
    id: '61685',
    name: 'Stinger',
    vrm: '/assets/stinger_avatar.vrm',
    glb: '/assets/stinger_avatar.vrm',
    image: '/assets/stinger_avatar.png'
  },
  {
    id: '2969',
    name: 'Sophia',
    vrm: '/assets/sophia_avatar.vrm',
    glb: '/assets/sophia_avatar.vrm',
    image: '/assets/sophia_avatar.png'
  }
];

export default function useActionFigureListing(address, signature) {
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  const fetchActionFigures = async () => {
    const tokens = HOMESCREEN_MODELS; // Allow free home models
    setIsLoading(true);
    const network = IS_PRODUCTION ? Network.BASE_MAINNET : Network.BASE_SEPOLIA;
    try {
      if (address) {
        const realTokens = await getAllOgs(address, signature);//await getAllNftsFromAlchemy(address, BASEJUMP_CONTRACT_ADDRESS, network);
        // For prod - only default guy should stay
        // const tokens = IS_PRODUCTION ? [DEFAULT_FIGURES[0]] : [...DEFAULT_FIGURES, ...MOCK_FIGURES];
        const ogTokens = await Promise.all(realTokens.map((t) => FigureModel.fromOgNft(t)));
        setItems([
          ...ogTokens,
          ...tokens.map((t) => FigureModel.fromAlchemyNft(t, true))
        ]);
      } else {
        throw new Error('No address');
      }
    } catch (e) {
      setItems([
        ...tokens.map((t) => FigureModel.fromAlchemyNft(t, true))
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActionFigures();
  }, [address, signature]);

  return { items, isLoading, fetchActionFigures };
}
